<!--
 * @Description: Jeson Create File
 * @Version: 1.0
 * @Autor: Jeson
 * @Date: 2021-11-16 14:28:45
 * @LastEditors: Luyaoyao
 * @LastEditTime: 2022-03-07 16:31:11
-->
<template>
  <div id="storey-item">
    <!-- 秒杀 -->
    <div v-if="storey.ItemValue == 8" class="storey-item-miaosha">
      <div class="storey-title">
        <img src="@/assets/home/clock.png">
        <div class="miaosha-title">
          <img src="@/assets/home/miaoshatitle.png">
        </div>
        <div
          v-if="storey.GoodsList.length > 0 && storey.GoodsList[0].ActivityInfo"
          class="miaosha_day"
        >
          <img src="@/assets/home/shandian.png">
          <span
            class="sub_title"
          >距活动结束仅剩
            <van-count-down
              :time="storey.GoodsList[0].ActivityInfo.TotalMilliseconds"
            >
              <template #default="timeData">
                <span class="day">{{ timeData.days + '天' }}</span>
                <span class="block">{{ timeData.hours | zero }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.minutes | zero }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.seconds | zero }}</span>
              </template>
            </van-count-down>
          </span>
        </div>
        <div
          class="miaosha_div"
          style="color: #FFFFFF;"
          @click.stop="toMore(storey)"
        >
          进入秒杀专区
        </div>
      </div>
      <div class="storey-item-miaosha-div">
        <div style="width: 100%;" class="goods-div">
          <div
            v-for="(item, index) in storey.GoodsList"
            :key="index"
            class="storey-item-miaosha-div-item"
          >
            <NewProductItem
              v-if="storey.GoodsList[index]"
              style="height: 100%;"
              :product="storey.GoodsList[index]"
            />
            <div v-else class="noproduct_div">
              <div />
            </div>
          </div>
          <div v-if="storey.GoodsList.length < 5" style="display: flex;">
            <div
              v-for="(item, index) in 5 - storey.GoodsList.length"
              :key="`M-${index}`"
              class="storey-item-miaosha-div-item"
            >
              <div class="noproduct_div">
                <div
                  style="
                  padding-top: 140%;
                  font-weight: 400;
                  color: #666F83;
                  background-size: 100%;
                  cursor: pointer;
"
                >
                  产品上架中...
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 特价 横-->
    <div v-if="storey.ItemValue == 13" class="storey-item-picture">
      <div
        class="storey-title"
        :style="{
          background: backgroundColor[index]
            ? backgroundColor[index]
            : 'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #D1E5FF 100%)'
        }"
      >
        <img :src="storey.StoreyTitleBackgroundImage">
        <div>{{ storey.SpecialName }}</div>
        <div>{{ storey.SpecialSubName && storey.SpecialSubName.split('<')[0] }}  {{ storey.SpecialSubName && storey.SpecialSubName.split('>')[1] }}</div>
        <div
          v-if="storey.IsShowMore == 1"
          style="cursor: pointer;"
          @click.stop="toMore(storey)"
        >
          查看更多
        </div>
      </div>
      <div class="storey-item-div">
        <div class="storey-item-title">
          <img :src="storey.StoreyBackgroundImage">
          <div class="storey-item-downtime-title" style="margin-top: 160px;">
            <div>{{ storey.SpecialSubName && storey.SpecialSubName.split('<')[0] }}  {{ storey.SpecialSubName && storey.SpecialSubName.split('>')[1] }}</div>
          </div>

          <div
            class="storey-item-btn"
            style="cursor: pointer;"
            @click.stop="toMore(storey)"
          >
            查看更多
          </div>
        </div>
        <div
          style="width: 100%; height: 100%; flex-wrap: wrap;"
          class="goods-div"
        >
          <div
            v-for="(item, index) in 4"
            :key="`T-${index}`"
            style="width: 50%; height: 50%;"
          >
            <NewProductItem
              v-if="storey.GoodsList[index]"
              :product="storey.GoodsList[index]"
              :type="'across'"
            />
            <div v-else class="noproduct_div">
              <div />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 当季热销  竖-->
    <div
      v-if="
        storey.ItemValue == 2 || storey.ItemValue == 10 || storey.ItemValue == 6
      "
      class="storey-item-picture"
    >
      <div
        class="storey-title"
        :style="{
          background: backgroundColor[index]
        }"
      >
        <img :src="storey.StoreyTitleBackgroundImage">
        <div>{{ storey.SpecialName }}</div>
        <div>{{ storey.SpecialSubName }}</div>
        <div
          v-if="storey.IsShowMore == 1"
          style="cursor: pointer;"
          @click.stop="toMore(storey)"
        >
          查看更多
        </div>
      </div>
      <div class="storey-item-div" style="height: 100%;">
        <div style="width: 100%; flex-wrap: wrap;" class="goods-div">
          <div
            v-for="(item, index) in storey.GoodsList"
            :key="`J-${index}`"
            style="margin: 4px 0;"
          >
            <NewProductItem
              v-if="storey.GoodsList[index]"
              style="height: 100%;"
              :product="storey.GoodsList[index]"
            />
            <div v-else class="noproduct_div_noacross">
              <div>产品上架中...</div>
            </div>
          </div>
          <div v-if="storey.GoodsList.length < 5" style="display: flex;">
            <div
              v-for="(item, index) in 5 - storey.GoodsList.length"
              :key="`M-${index}`"
              class="storey-item-miaosha-div-item"
              style="width: 235px;"
            >
              <div class="noproduct_div" style="padding: 4px;">
                <div
                  style="
                  padding-top: 140%;
                  font-weight: 400;
                  color: #666F83;
                  background-size: 100%;
                  cursor: pointer;
"
                >
                  产品上架中...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 厂家专区 -->
    <div v-if="storey.ItemValue == 7" class="storey-item-factory">
      <div class="storey-item-factory-img">
        <img
          v-for="(item, index) in storey.FacList"
          :key="index"
          :src="item.Logo"
          fit="cover"
          @click.stop="toFactory(item.Id)"
        >
      </div>
      <div
        class="storey-item-factory-title"
        :style="{
          backgroundImage: `url(${StoreyTitleBackgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%'
        }"
      >
        <div>厂家让利 特供直销</div>
        <div style="cursor: pointer;" @click.stop="toMore(storey)">进入专区</div>
      </div>
    </div>
    <!-- 固定图片楼层 -->
    <div v-if="storey.ItemValue == 1" class="storey-item-staticImg">
      <div class="storey-item-staticImg-img">
        <img :src="storey.staticImg" fit="cover">
      </div>
    </div>
    <!-- 药店热销 -->
    <div v-if="storey.ItemValue == 11" class="storey-item-drugstore">
      <div
        class="storey-title"
        :style="{
          background: backgroundColor[index]
        }"
      >
        <img :src="storey.StoreyTitleBackgroundImage">
        <div>{{ storey.SpecialName }}</div>
        <div>{{ storey.SpecialSubName }}</div>
        <div
          v-if="storey.IsShowMore == 1"
          style="cursor: pointer;"
          @click.stop="toMore(storey)"
        >
          查看更多
        </div>
      </div>
      <div class="storey-tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="(i, k) in storey.PharmacyDto"
            :key="k"
            :label="i.CategoryTitle"
            :name="`${k}`"
          >
            <div v-if="i.CategoryGoodsList.length > 0" class="storey-tabs-div">
              <div
                v-for="(item, index) in i.CategoryGoodsList"
                :key="index"
                style="height: 100%;"
                class="storey-tabs-item"
                @click="toDetail(item.Id)"
              >
                <NewProductItem style="height: 100%;" :product="item" />
                <!-- <div class="noproduct_div_noacross" else>
                  <div />
                </div> -->
              </div>
              <div v-if="i.CategoryGoodsList.length < 5" style="height: 100%;">
                <div
                  v-for="(item, index) in 5 - i.CategoryGoodsList.length"
                  :key="`Yd-${index}`"
                  style="width: 240px; height: 100%;"
                  class="storey-tabs-item"
                >
                  <div class="noproduct_div_noacross" else>
                    <div>产品上架中...</div>
                  </div>
                </div>
              </div>

            </div>
            <div v-else class="storey-tabs-div">
              <div
                v-for="(item, index) in 5"
                :key="`Y-${index}`"
                style="height: 100%;"
                class="storey-tabs-item"
              >
                <div class="noproduct_div_noacross">
                  <div>产品上架中...</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 诊所热销 -->
    <div v-if="storey.ItemValue == 12" class="storey-item-drugstore">
      <div
        class="storey-title"
        :style="{
          background: backgroundColor[index]
        }"
      >
        <img :src="storey.StoreyTitleBackgroundImage">
        <div>{{ storey.SpecialName }}</div>
        <div>{{ storey.SpecialSubName }}</div>
        <div
          v-if="storey.IsShowMore == 1"
          style="cursor: pointer;"
          @click.stop="toMore(storey)"
        >
          查看更多
        </div>
      </div>
      <div class="storey-tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="(i, k) in storey.PharmacyDto"
            :key="`ZSss-${k}`"
            :label="i.CategoryTitle"
          >
            <div v-if="i.CategoryGoodsList.length > 0" class="storey-tabs-div">
              <div
                v-for="(item, index) in i.CategoryGoodsList"
                :key="index"
                style="width: 240px; height: 100%;"
                class="storey-tabs-item"
                @click="toDetail(item.Id)"
              >
                <NewProductItem style="height: 100%;" :product="item" />
                <!-- <div class="noproduct_div_noacross" else>
                  <div />
                </div> -->
              </div>
              <div v-if="i.CategoryGoodsList.length < 5" style="height: 100%;">
                <div
                  v-for="(item, index) in 5 - i.CategoryGoodsList.length"
                  :key="`ZSS-${index}`"
                  style="height: 100%;"
                  class="storey-tabs-item"
                >
                  <div class="noproduct_div_noacross" else>
                    <div>产品上架中...</div>
                  </div>
                </div>
              </div>

            </div>
            <div v-else class="storey-tabs-div">
              <div
                v-for="(item, index) in 5"
                :key="`ZSSS-${index}`"
                style="height: 100%;"
                class="storey-tabs-item"
              >
                <div class="noproduct_div_noacross">
                  <div>产品上架中...</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 品牌 -->
    <div v-if="storey.ItemValue == 1" class="storey-item-brand">
      <div class="storey-item-brand-img">
        <div
          v-for="(item, index) in storey.BrandList"
          :key="index"
          class="item"
        >
          <div class="one">
            <img
              :src="item.BrandItemImage"
              fit="cover"
              @click.stop="toBrand(item)"
            >
          </div>
        </div>
      </div>
      <div class="storey-item-brand-title">
        <div v-if="storey.IsShowMore == 1" @click.stop="toMore(storey)">
          更多品牌
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
import NewProductItem from './NewProductItem.vue'

export default {
  name: 'StoreyItemsTemplate',
  components: { NewProductItem },
  filters: {
    zero(v) {
      return v < 10 ? `0${v}` : v
    }
  },
  mixins: [BaseMixin],
  props: {
    storey: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      iShowItems: [],
      Type: 1,
      activeName: 0,
      backgroundColor: [
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFD8D8 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFE7DB 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #D1E5fe 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFD8D8 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFE7DB 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #D1E5fe 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFD8D8 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFE7DB 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #D1E5fe 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFD8D8 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFE7DB 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #D1E5fe 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFD8D8 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFE7DB 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #D1E5fe 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFD8D8 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFE7DB 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #D1E5fe 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFD8D8 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFE7DB 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #D1E5fe 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFD8D8 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFE7DB 100%)',
        'linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #D1E5fe 100%)'
      ],
      StoreyTitleBackgroundImage: require('@/assets/home/factorytitle.png')
    }
  },
  mounted() {
    // 保存需要显示的数据
    this.iShowItems = this._initShowItems(this.storey)
  },
  created() {},
  destroyed() {},
  methods: {
    toFactory(Id) {
      this._jump('FactoryMoreList', Id, '_blank')
    },
    toDetail(Id) {
      this._jump(this.Enum_LinkTypeCode.ProductDetails, Id, '_blank')
    },
    // 切换tabs
    handleClick(tab, event) {
      console.log(tab, event)
    },
    // 查看更多
    toMore(item) {
      const LinkType = item.MoreType
      let LinkValue = ''

      if (LinkType == 12) {
        // 指定商品
        LinkValue = item.MoreValues.toString()
      } else if (LinkType == 52) {
        // 商品详情
        LinkValue = item.MoreValues[0]
      } else {
        LinkValue = item.MoreValue
      }

      const path = this._getTurnUrl(LinkType, LinkValue)
      this._jump(path, LinkValue, '_blank')
    },
    toBrand(item) {
      this._jump('BrandMoreList', item.BrandItemLinkValue, '_blank')
    }
  }
}
</script>

<style lang="less">
#storey-item {
  .goods-div {
    display: flex;
    padding: 12px;
  }

  .goods-item {
    width: 227px;
    background: #FFFFFF;
    cursor: pointer;
  }

  .storey-item-miaosha {
    width: 100%;
    background:
      linear-gradient(
        165deg,
        #FF0202 0%,
        #FF450F 40%,
        #FF6407 82%,
        #FF6506 100%
      );

    .storey-title {
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 8px;
      width: 100%;
      height: 64px;

      :nth-child(1) {
        // width: 24px;
        display: inline-block;
        height: 24px;
      }

      .miaosha-title {
        width: 137px;

        img {
          margin: 12px;
          width: 100%;
          height: 100%;
        }
      }

      .miaosha_day {
        margin-left: 36px;
        height: 24px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;

        .day {
          margin: 0 4px;
          height: 24px;
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
        }

        .block {
          display: inline-block;
          border-radius: 4px;
          width: 28px;
          height: 28px;
          font-size: 20px;
          font-family: Avenir-Heavy, Avenir;
          font-weight: 800;
          text-align: center;
          color: #FFFFFF;
          background: #111A34;
          line-height: 28px;
        }

        .colon {
          padding: 0 4px;
        }
      }

      .miaosha_div {
        position: absolute;
        right: 24px;
        border: 1px solid #FFFFFF;
        border-radius: 16px;
        width: 128px;
        height: 32px;
        font-size: 16px;
        font-weight: 400;
        background: rgba(180, 0, 0, .31);
        cursor: pointer;
        line-height: 32px;
      }
    }

    .storey-item-miaosha-div {
      width: 100%;

      .goods-div {
        flex-wrap: wrap;

        .storey-item-miaosha-div-item {
          // width: 227px;
          margin: 4px 0;

          .noproduct_div {
            padding: 2px 4px;
            width: 235px;
            height: 100%;

            div {
              border: 1px solid #F3F5F7;
              width: 100%;
              height: 100%;
              background: white;
              background-position: 50%;
              background-repeat: no-repeat;
              background-size: 50%;
              background-image: url('../../assets/home/noproduct.png');
            }
          }
        }
      }
    }
  }

  .storey-item-picture {
    background: #FFFFFF;
    cursor: pointer;

    .storey-item-div {
      display: flex;
      height: 494px;

      .storey-item-title {
        position: relative;
        display: flex;
        justify-content: center;

        img {
          width: 244px;
          height: 494px;
        }

        .storey-item-clock {
          position: absolute;
          margin-top: 111px;
        }

        .storey-item-time {
          position: absolute;
          margin-top: 163px;
          border-radius: 4px;
          width: 84px;
          height: 24px;
          font-size: 16px;
          font-weight: 600;
          color: #111A34;
          background: linear-gradient(163deg, #FFFFFF 0%, #FFE375 100%);
          line-height: 24px;
        }

        .storey-item-downtime-title {
          position: absolute;
          margin-top: 231px;
          height: 14px;
          font-size: 14px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 14px;
        }

        .storey-item-downtime {
          position: absolute;
          margin-top: 257px;

          .storey-item-dian {
            display: inline-block;
            margin: 0 3px;
            height: 40px;
            font-size: 24px;
            line-height: 40px;
          }

          .storey-item-span {
            display: inline-block;
            margin: 0 3px;
            border-radius: 4px;
            width: 40px;
            height: 40px;
            font-size: 24px;
            font-weight: 800;
            color: white;
            background: #111A34;
            line-height: 40px;
          }
        }
      }

      .storey-item-btn {
        position: absolute;
        margin-top: 351px;
        border: 1px solid #FFFFFF;
        border-radius: 16px;
        width: 128px;
        height: 32px;
        font-size: 16px;
        line-height: 32px;
        font-weight: 400;
        color: #FFFFFF;
      }
    }

    .storey-title {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 64px;

      img {
        margin-left: 16px;
        width: 24px;
        height: 24px;
      }

      :nth-child(2) {
        margin-left: 8px;
        height: 24px;
        font-size: 24px;
        font-weight: 600;
        color: #111A34;
        line-height: 24px;
      }

      :nth-child(3) {
        margin-left: 12px;
        height: 12px;
        font-size: 12px;
        font-weight: 400;
        color: #666F83;
        line-height: 12px;
      }

      :nth-child(4) {
        position: absolute;
        right: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #111A34;
      }
    }
  }

  .storey-item-factory {
    display: flex;
    width: 100%;
    height: 236px;
    background: white;

    .storey-item-factory-img {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: calc(100% - 236px);
      height: 100%;
      flex-wrap: wrap;

      img {
        margin: 7px;
        width: 172px;
        height: 96px;
      }
    }

    .storey-item-factory-title {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 236px;
      height: 236px;
      text-align: center;
      flex-direction: column;

      :first-child {
        margin-top: 25%;
        height: 16px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 16px;
      }

      :last-child {
        margin-top: 10%;
        border: 1px solid #FFFFFF;
        border-radius: 16px;
        width: 128px;
        height: 32px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        background: rgba(180, 0, 0, .31);
        line-height: 32px;
      }
    }
  }

  .storey-item-drugstore {
    width: 100%;
    background: white;

    .storey-title {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 64px;

      img {
        margin-left: 16px;
        width: 24px;
        height: 24px;
      }

      :nth-child(2) {
        margin-left: 8px;
        height: 24px;
        font-size: 24px;
        font-weight: 600;
        color: #111A34;
        line-height: 24px;
      }

      :nth-child(3) {
        margin-left: 12px;
        height: 12px;
        font-size: 12px;
        font-weight: 400;
        color: #666F83;
        line-height: 12px;
      }

      :nth-child(4) {
        position: absolute;
        right: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #111A34;
      }
    }

    .storey-tabs {
      .storey-tabs-div {
        display: flex;
        width: 100%;
      }

      .el-tabs__header,
      .is-top {
        font-size: 20px;
        font-weight: 500;
        color: #111A34;
      }

      .el-tabs__header {
        padding: 0 48px;
      }

      .el-tabs__content {
        padding-bottom: 8px;
        width: 100%;

        .storey-tabs-div {
          display: flex;
          width: 100%;
          height: 457px;
          flex-wrap: wrap;

          .storey-tabs-item {
            width: 240px;
          }
        }
      }
    }
  }

  .storey-item-staticImg {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .storey-item-brand {
    position: relative;
    display: flex;
    width: 100%;
    height: 140px;

    .storey-item-brand-img {
      position: absolute;
      display: flex;
      width: calc(100% - 56px);
      height: 100%;
      box-shadow:
        0 2px 11px 0 rgba(219, 219, 219, 1),
        0 3px 8px 0 rgba(193, 193, 193, .5);
      flex-wrap: nowrap;

      .item:hover {
        cursor: pointer;
        box-shadow: 0 3px 8px 0 rgba(193, 193, 193, .5);
      }

      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        // border: 1px solid #FFFFFF;
        border-radius: 4px;
        width: 288px;
        height: 142px;

        .one {
          width: 100%;
          height: 100%;

          img {
            overflow: hidden;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .storey-item-brand-title {
      position: absolute;
      right: 0;
      margin: auto;
      width: 56px;
      height: 100%;
      line-height: 100%;
      text-align: center;
      background: #1163E6;
      list-style: none;
      cursor: pointer;

      div {
        width: 64%;
        height: 100%;
        color: white;
        letter-spacing: .3em;
        writing-mode: vertical-rl;
      }
    }
  }

  // 横
  .noproduct_div {
    padding: 8px;
    width: 100%;
    height: 100%;

    div {
      border: 1px solid #F3F5F7;
      width: 100%;
      height: 100%;
      background: white;
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: 50%;
      background-image: url('../../assets/home/noproduct.png');
    }
  }

  .noproduct_div_noacross {
    padding: 0 4px;
    width: 235px;
    height: 100%;

    div {
      border: 1px solid #F3F5F7;
      padding-top: 140%;
      width: 100%;
      height: 100%;
      font-weight: 400;
      color: #666F83;
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: 100%;
      background-image: url('../../assets/home/noproduct.png');
      line-height: 14px;
    }
  }
}
</style>
